module.exports = __webpack_public_path__ + "static/logo_text_beta-e96f671b7666a22169698e551ea828f0.png";